import { Component, OnInit, Renderer2 } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { ERTMedicalRunSheetService } from "../../../services/emergency-response/medical-runsheet.service";
import { ERTEmergencyResponse } from "../../../interfaces/emergencyresponse/emergencyresponse";
import { ERTEmergencyResponseService } from "../../../services/emergency-response/emergency-response.service";
import { ERTGender } from "../../../interfaces/emergencyresponse/medical-runsheet-enum";
import { ERTUserService } from "../../../services/ert-user/ert-user.service";
import { ERTUser } from "../../../interfaces/ert-user/ert-user";
import { LoggedUserService } from "../../../services/common/logged-user.service";

@Component({
  selector: "app-ert-emergency-response-addmrs-create",
  templateUrl: "./ert-emergency-response-addmrs-create.component.html",
  styles: [
    `
      ::ng-deep mat-expansion-panel-header .mat-expansion-indicator {
        display: none;
      }
      ::ng-deep mat-icon {
        color: white !important;
      }
    `,
  ],
})
export class ErtEmergencyResponseAddmrsCreateComponent implements OnInit {
  emergencyResponseId: string;
  incidentInfoPanelOpenState = true;
  patientInfoPanelOpenState = true;
  additionalInfoPanelOpenState = true;

  emergencyResponse: ERTEmergencyResponse;
  patientGenders = ERTGender;
  ertUsers: ERTUser[] = [];
  location: string;
  icName: string;
  validationMessages: string[] = [];

  facilityId: number = 0;

  constructor(
    private route: ActivatedRoute,
    private ertUserService: ERTUserService,
    private ertEmergencyResponseService: ERTEmergencyResponseService,
    public ertMedicalRunSheetService: ERTMedicalRunSheetService,
    private renderer: Renderer2,
    private router: Router,
    private loggedUserService: LoggedUserService
  ) {}

  ngOnInit(): void {   
    this.route.queryParams.subscribe((params) => {
      this.emergencyResponseId = params["emergencyResponseId"];
    });

    this.loggedUserService.getLoggedUserData().subscribe((user) => {
      let fullName = user.firstName + " " + user.lastName;
      this.facilityId = Number(user.facilityId) || 0;

      this.ertUserService.getAllERTUsers(this.facilityId).subscribe((data) => {
        this.ertUsers = data;
        this.ertUsers = data.filter((user) =>
          user.picklistValues.some((picklist) => picklist.value === "PP")
        );
        this.ertUsers.sort((a, b) => a.lastName.localeCompare(b.lastName));

        // Set the default IC value to the current logged-in user or first in list
        if (this.ertUsers.length > 0) {
          const currentLoggedInUser = this.ertUsers.find(
            (u) => u.fullName === fullName
          );
          if (currentLoggedInUser) {
            this.ertMedicalRunSheetService.ertMedicalRunSheetForm.patchValue({
              incidentCommander: currentLoggedInUser.fullName,
            });
          } else {
            this.ertMedicalRunSheetService.ertMedicalRunSheetForm.patchValue({
              incidentCommander: this.ertUsers[0].fullName,
            });
          }
        }
      });
    });

    this.ertEmergencyResponseService
      .getERTEmergencyResponseById(Number(this.emergencyResponseId), this.facilityId)
      .subscribe((data) => {
        this.emergencyResponse = data;
        this.location = this.emergencyResponse.incidentCommander.facility.name;
        this.icName = this.emergencyResponse.incidentCommander.fullName;

        this.ertMedicalRunSheetService.ertMedicalRunSheetForm.patchValue({
          incidentCommander: this.emergencyResponse.incidentCommander.fullName,
        });
      });
  }

  getEnumKeys(enumObj: any): string[] {
    return Object.keys(enumObj).filter((key) => isNaN(Number(key)));
  }

  goToNextStep() {
    this.validationMessages =
      this.ertMedicalRunSheetService.validateNewERTMedicalRunSheetStep1(
        this.ertMedicalRunSheetService.ertMedicalRunSheetForm
      );
    this.scrollToTop();

    // Handle enum conversion before navigation
    const formValues =
      this.ertMedicalRunSheetService.ertMedicalRunSheetForm.getRawValue();
    if (
      formValues.patientGender &&
      typeof formValues.patientGender === "string"
    ) {
      const numericValue = parseInt(formValues.patientGender);
      if (!isNaN(numericValue)) {
        this.ertMedicalRunSheetService.ertMedicalRunSheetForm.patchValue({
          patientGender: numericValue,
        });
      }
    }

    // Setup medical runsheet object with proper enum values
    this.ertMedicalRunSheetService.newERTMedicalRunSheet = {
      ...this.ertMedicalRunSheetService.newERTMedicalRunSheet,
      emergencyResponseId: Number(this.emergencyResponseId),
      patientGender: Number(formValues.patientGender),
    };

    if (this.validationMessages.length === 0) {
      this.router.navigate(
        ["/ert-emergency-response/emergency-response-addmrs-additional-info"],
        {
          queryParams: { emergencyResponseId: this.emergencyResponseId },
        }
      );
    }
  }

  private scrollToTop() {
    this.renderer.setProperty(document.documentElement, "scrollTop", 0);
    this.renderer.setProperty(document.body, "scrollTop", 0);
  }
}
